import { useCallback, useState } from 'react'
import { createFileRoute, useNavigate, useRouter } from '@tanstack/react-router'

import {
    ZALO_CALLBACK_PATH,
    ZaloCallback,
    readCallbackSearch,
} from '@/components/zalo/zalo-callback'
import { requireServerFlag } from '@/lib/server-flag-guard'
import { queryClient } from '@/router'

// Trang Zalo chuyển về sau khi cấp quyền OA (redirect_uri). NGOÀI guard
// _authed: guard đó chuyển sang /login và làm mất code (spec §6.1 #3, #8).
// ZALO_OA_ENABLED tắt → không tồn tại; chưa đăng nhập (chưa biết cờ) vẫn hiện
// để giữ bước "Đăng nhập để hoàn tất".
export const Route = createFileRoute('/_app/settings/zalo/callback')({
    beforeLoad: () =>
        requireServerFlag(queryClient, 'server:zalo-oa', {
            allowUnknown: true,
        }),
    component: CallbackPage,
})

function CallbackPage() {
    // Chuỗi thô, đọc một lần trước khi xoá query (xem readCallbackSearch).
    const [search] = useState(() => readCallbackSearch(window.location.search))
    const navigate = useNavigate()
    const router = useRouter()
    const clearQuery = useCallback(
        () => router.history.replace(ZALO_CALLBACK_PATH),
        [router],
    )
    return (
        <ZaloCallback
            search={search}
            clearQuery={clearQuery}
            onLogin={() =>
                void navigate({
                    to: '/login',
                    search: { redirect: ZALO_CALLBACK_PATH },
                })
            }
            onBack={() => void navigate({ to: '/settings/zalo' })}
        />
    )
}
